import React, { type CSSProperties } from 'react';
import ReadinessChecklist from '@/components/onboarding/ReadinessChecklist';
import SidebarProvider from '@/components/sidebar/SidebarProvider';
import { TrialBanner } from '@/components/subscription/TrialBanner';
import { useAuth } from '@/context/AuthContext';
import { useEntitlements } from '@/hooks/use-entitlements';
import { ReportPage } from './constants';

interface LayoutProps {
    children: React.ReactNode;
    currentPageName?: string;
}

interface AdminLayoutProps {
    children: React.ReactNode;
}

function AdminLayout({ children }: AdminLayoutProps) {
    const { logout } = useAuth();
    const { entitlements } = useEntitlements();

    const hasTrialBanner = entitlements?.status === 'trial';

    return (
        <SidebarProvider onLogout={() => logout()}>
            {hasTrialBanner ? <TrialBanner periodEnd={entitlements.period_end} /> : null}
            {/* `TrialBanner` é `sticky top-0` no mesmo container de scroll: sem este
                offset todo header `sticky` gruda na mesma coordenada e some atrás dele. */}
            <div
                className="contents"
                style={{ '--app-sticky-top': hasTrialBanner ? '2.25rem' : '0px' } as CSSProperties}
            >
                {children}
            </div>
            <ReadinessChecklist />
        </SidebarProvider>
    );
}

export default function Layout({ children, currentPageName }: LayoutProps) {
    if (currentPageName === ReportPage) {
        return <>{children}</>;
    }

    return <AdminLayout>{children}</AdminLayout>;
}
